import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from "vue";
import { versionToString } from "@/util";
import {
  appStore,
  artifactStore,
  projectStore,
  timStore,
  traceStore,
} from "@/hooks";
import {
  PanelCard,
  AttributeChip,
  FlexBox,
  Icon,
  TextButton,
  Typography,
} from "@/components/common";
import SaveProjectInputs from "./SaveProjectInputs.vue";


/**
 * Displays high level project information.
 */
const __default__ = {
  name: "ProjectDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editMode = computed(() => appStore.popups.editProject);

const project = computed(() => projectStore.project);

const name = computed(() => projectStore.project.name || "No Project");

const versionLabel = computed(
  () => `Version ${versionToString(project.value.projectVersion)}`
);

const artifactTypeLabel = computed(
  () => `${timStore.artifactTypes.length} Artifact Types`
);

const artifactLabel = computed(
  () => `${artifactStore.allArtifacts.length} Artifacts`
);

const traceLabel = computed(() => `${traceStore.allTraces.length} Trace Links`);

const artifactTypeMap = computed(() =>
  Object.entries(
    timStore.traceMatrices.reduce(
      (acc, matrix) => ({
        ...acc,
        [matrix.targetType]: [
          ...(acc[matrix.targetType] || []),
          matrix.sourceType,
        ],
      }),
      timStore.artifactTypes
        .map(({ name }) => ({ [name]: [] }))
        .reduce(
          (acc, cur) => ({ ...acc, ...cur }),
          {} as Record<string, string[]>
        )
    )
  )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), { title: name.value }, {
    "title-actions": _withCtx(() => [
      (editMode.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            label: "Cancel",
            icon: "cancel",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).close('editProject')))
          }))
        : (_openBlock(), _createBlock(_unref(Typography), {
            key: 1,
            secondary: "",
            value: versionLabel.value
          }, null, 8, ["value"]))
    ]),
    default: _withCtx(() => [
      (!editMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(FlexBox), {
              column: "",
              b: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Typography), {
                  value: "Project Data",
                  variant: "caption"
                }),
                _createVNode(_unref(Typography), { value: artifactTypeLabel.value }, null, 8, ["value"]),
                _createVNode(_unref(Typography), { value: artifactLabel.value }, null, 8, ["value"]),
                _createVNode(_unref(Typography), { value: traceLabel.value }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(Typography), {
              value: "Artifact Types",
              variant: "caption"
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(artifactTypeMap.value, ([parent, children]) => {
              return (_openBlock(), _createBlock(_unref(FlexBox), {
                key: parent,
                column: "",
                t: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AttributeChip), {
                    "artifact-type": "",
                    value: parent
                  }, null, 8, ["value"]),
                  (children.length > 0)
                    ? (_openBlock(), _createBlock(_unref(FlexBox), {
                        key: 0,
                        l: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Icon), {
                            class: "q-mx-xs q-mt-xs",
                            size: "sm",
                            color: "text",
                            variant: "trace",
                            rotate: -90
                          }),
                          _createVNode(_unref(FlexBox), { column: "" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, (child) => {
                                return (_openBlock(), _createBlock(_unref(AttributeChip), {
                                  key: child,
                                  "artifact-type": "",
                                  value: child
                                }, null, 8, ["value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(SaveProjectInputs, {
            key: 1,
            onSave: _cache[1] || (_cache[1] = ($event: any) => (_unref(appStore).close('editProject')))
          }))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})